import sortObject from 'sort-object-keys';

export function stringify(value: unknown): string {
  if (typeof value === 'object') {
    return JSON.stringify(sortObject(value));
  }
  return String(value);
}
